import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Episodes',
    href: '#'
  }, {
    name: 'About the Show',
    href: '#'
  }, {
    name: 'Host',
    href: '#'
  }, {
    name: 'Be a Guest',
    href: '#'
  }, {
    name: 'Contact',
    href: '#'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${isScrolled ? 'bg-eofa-black shadow-lg' : 'bg-transparent'}`} data-id="element-75">
      <div className="container mx-auto px-6 h-[60px] md:h-20 flex items-center justify-between" data-id="element-76">
        {/* Logo */}
        <a href="#" className="flex-shrink-0" data-id="element-77">
          <img src="https://cdn.magicpatterns.com/uploads/6DgCkWRHtBFs2JEwqHrY5r/e-of-a-logo-v2.png" alt="Entrepreneurs of America by LetLois" className="h-10 md:h-12 w-auto" data-id="element-78" />
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center space-x-8" data-id="element-79">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-eofa-white text-sm font-medium hover:text-eofa-yellow transition-colors" data-id="element-80">
              {link.name}
            </a>)}
        </nav>

        {/* Right CTA & Mobile Toggle */}
        <div className="flex items-center space-x-4" data-id="element-81">
          <button className="hidden md:flex items-center justify-center bg-eofa-yellow text-eofa-black font-bold rounded-md px-6 min-h-[44px] hover:bg-yellow-400 transition-colors" data-id="element-82">
            Subscribe
          </button>

          <button className="md:hidden text-eofa-white p-2 -mr-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-83">
            {isMobileMenuOpen ? <X size={24} data-id="element-84" /> : <Menu size={24} data-id="element-85" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-eofa-black border-t border-eofa-dark p-6 flex flex-col space-y-6 shadow-2xl" data-id="element-86">
          <nav className="flex flex-col space-y-4" data-id="element-87">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-eofa-white text-lg font-medium hover:text-eofa-yellow transition-colors" onClick={() => setIsMobileMenuOpen(false)} data-id="element-88">
                {link.name}
              </a>)}
          </nav>
          <button className="w-full flex items-center justify-center bg-eofa-yellow text-eofa-black font-bold rounded-md px-6 min-h-[48px] hover:bg-yellow-400 transition-colors" data-id="element-89">
            Subscribe
          </button>
        </div>}
    </header>;
}